import { plural } from '../domain/format'
import { useState } from 'react'

/**
 * Says out loud what just happened, for anyone not watching the screen.
 *
 * Loading reports or finishing a sync changes the page without moving focus,
 * so a screen reader user would otherwise not learn it happened. One polite
 * region for the whole application, rather than one per view. Mounted once
 * the stored session is back, so restoring it is not announced as a load.
 */
export function Announcer({
  reportCount,
  syncMessage,
}: {
  reportCount: number
  syncMessage: string | undefined
}) {
  const [message, setMessage] = useState('')
  const [seen, setSeen] = useState({ reportCount, syncMessage })

  // Reacting to a change in props while rendering, as React recommends over an
  // effect: the message updates in the same render as what it describes.
  if (seen.reportCount !== reportCount || seen.syncMessage !== syncMessage) {
    const added = reportCount - seen.reportCount
    setSeen({ reportCount, syncMessage })
    if (syncMessage && syncMessage !== seen.syncMessage) setMessage(syncMessage)
    else if (added > 0) {
      setMessage(`Loaded ${added} ${plural(added, 'assessment')}. ${reportCount} in this session.`)
    }
  }

  return (
    <div className="visually-hidden" role="status" aria-live="polite">
      {message}
    </div>
  )
}
